module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-container"
  }, _vm._l((_vm.contents), function(item, index) {
    return _c('div', {
      staticClass: "faq-question",
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [_c('div', {
      staticClass: "faq-description"
    }, [_vm._v(_vm._s(item.title) + " "), (item.situacao) ? [_vm._v("(" + _vm._s(item.situacao) + ")")] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "faq-content",
      staticStyle: {
        "display": "none"
      }
    }, [_c('p', [_vm._v(_vm._s(item.msg1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.msg2))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28aa17c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AccordionMenu.vue
// module id = 97
// module chunks = 0